module.exports = __webpack_public_path__ + "static/media/glimmer.0bbef4ba.mp3";